import React from 'react';
import { Quote } from '@1debit/icons';
import { Node as ContentfulNode } from '@contentful/rich-text-types';
import { DocumentWithEmbeddedEntries } from 'libs/contentful/types';
import RichTextCopy from 'components/shared/RichTextCopy/RichTextCopy';
import Media from 'components/shared/Media/Media';
import { EmbeddedNode } from 'components/shared/RichTextTable/types';

const renderBlockEmbeddedEntry = (
  node: ContentfulNode,
  _children: React.ReactNode,
  content: DocumentWithEmbeddedEntries,
) => {
  const embeddedNode = node as EmbeddedNode;
  const blockEntries = content?.links?.entries?.block || [];
  const entry = blockEntries.find((i: { sys?: { id: string } }) => i.sys?.id === embeddedNode.data.target.sys.id);

  if (!entry) return null;

  switch (entry.__typename) {
    case 'TestimonialItem':
      return (
        <blockquote
          className="flex flex-col justify-center items-start gap-8 self-stretch rounded-lg bg-[#C5EECE] p-6 text-content-primary"
          data-testid="blockEmbeddedTestimonialItem">
          {entry.media?.url && (
            <div className="relative w-24 h-24 rounded-lg overflow-hidden">
              <Media
                media={{ ...entry.media, fill: true }}
                className="object-cover"
                sizes="96px"
                roundedImage={false}
              />
            </div>
          )}
          <Quote size={48} />
          <div className="font-serif text-body-serif">
            <RichTextCopy copy={entry.copy} />
          </div>
          {entry.attributionRte && (
            <footer className="font-sans text-[16px] font-[670] leading-[125%]">
              <RichTextCopy copy={entry.attributionRte} />
            </footer>
          )}
        </blockquote>
      );
    default:
      return null;
  }
};

export default renderBlockEmbeddedEntry;
